import { AbstractControl, FormControl } from '@angular/forms';

export function validateTrimmed(control: FormControl | AbstractControl) {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isNotWhitespace = !isWhitespace;
  return isNotWhitespace ? null : { whitespace: true };
}

export function valueTrimmed(value: string | null): string | null {
  if (!value) {
    return null;
  }
  const trim = value?.trim();
  if (trim.length === 0) {
    return null;
  }
  return trim;
}
